<template>
  <filter-summary
    icon="user-brand"
    title="ジャーナルデータ"
    :scroll-to-id="scrollToId"
    v-on="$listeners"
    :errors="errors"
  >
    <div>{{ filename }}</div>
  </filter-summary>
</template>

<script>
import FilterSummary from '@/components/FilterSummary.vue'

/**
 * 「ジャーナルデータ」の目次
 */
export default {
  components: { FilterSummary },
  props: {
    scrollToId: String,
    filename: {
      type: String,
    },
    errors: {
      type: Array,
    },
  },
  computed: {
    listeners() {
      return {
        ...this.$listeners,
      }
    },
  },
}
</script>
